export default {
  cscName: 'CSC 名称',
  reportType: '报表类型',
  giDate: 'GI 日期',
  orderType: '订单类型',
  shipFrom: 'Ship From',
  shipTo: 'Ship To',
  byCarton: '箱/(箱)',
  byExp: '运单号/(运单号)',
  byPiece: '件/(件)',
  cordCarton: 'CORD 箱数',
  cordCartonExp: '运单单数',
  noScanQty: 'No Scan 箱数/单数',
  rfidScannedQty: 'RFID扫描箱数/单数',
  accurateQty: 'Accurate箱数/单数',
  epcShortageQty: 'EPC少件箱数/单数',
  epcOverageQty: 'EPC多件箱数/单数',
  upcMismatchQty: 'UPC混件箱数/单数',
  unexpectedQty: 'Unexpected箱数/单数',
  byCartonAccuracy: '箱/单准确率',
  cordEpcQty: 'CORD件数',
  noScanQtyPiece: 'No Scan件数',
  rfidScannedQtyPiece: 'RFID扫描件数',
  accurateQtyPiece: 'Accurate件数',
  epcShortageGapQtyPiece: 'EPC少件差异件数',
  epcOverageGapQtyPiece: 'EPC多件差异件数',
  upcMismatchQtyPiece: 'UPC混件件数',
  unexpectedQtyPiece: 'Unexpected件数',
  byEpcAccuracy: '件准确率',
  tipTitle1: `Carton (by Carton) / EXP No. (by EXP No.)`,
  tip1: `CORD Carton/EXP No. Qty: CORD post至T-HUB的箱/单数量`,
  tip2: `No Scan Qty: CORD post至T-HUB但是未经过WMS扫描的箱/单数量`,
  tip3: `RFID Scanned Qty: WMS扫描的箱/单数量(去重)`,
  tip4: `Accurate Qty: CORD 箱/单内UPC件数与WMS箱/单内UPC件数完全相符箱/单数量`,
  tip5: `EPC Shortage Qty: 同一箱/单号，WMS箱/单内UPC件数少于CORD箱/单内UPC件数的箱/单数量`,
  tip6: `EPC Overage Qty: 同一箱/单号，WMS箱/单内UPC件数少多于CORD箱/单内UPC件数的箱/单数量`,
  tip7: `UPC Mismatch Qty: 同一箱/单号，WMS相较于CORD箱/单内混入额外UPC，或者存在A UPC少，B UPC多的情况的箱/单数量`,
  tip8: `Unexpected Qty: WMS扫描但是无CORD记录的箱/单数量`,
  tip9: `By Carton Accuracy: Accurate Qty / (CORD Carton/EXP No. Qty)`,
  tipTitle2: `Piece (by Piece)`,
  tipPiece1: `CORD EPC Qty: CORD post至T-HUB的产品箱/单内件数量`,
  tipPiece2: `No Scan Qty (Piece): CORD post至T-HUB但是未经过WMS扫描的箱/单内件数`,
  tipPiece3: `RFID Scanned Qty (Piece): WMS扫描的箱/单内件数(EPC去重)`,
  tipPiece4: `Accurate Qty (Piece): CORD 箱/单内UPC件数与WMS箱/单内UPC件数完全相符箱/单内件数`,
  tipPiece5: `EPC Shortage Gap Qty (Piece): 同一箱/单号，WMS箱/单内UPC件数少于CORD箱/单内UPC件数的箱/单, 统计Acutal Order Qty - RFID Scan Qty总差异件数`,
  tipPiece6: `EPC Overage Gap Qty (Piece): 同一箱/单号，WMS箱/单内UPC件数多于CORD箱/单内UPC件数的箱/单, 统计RFID Scan Qty - Acutal Order Qty 总差异件数`,
  tipPiece7: `UPC Mismatch Qty (Piece): 同一箱/单号，WMS相较于CORD箱/单内混入额外UPC，或者存在A UPC少，B UPC多的情况的箱/单内件数`,
  tipPiece8: `Unexpected Qty (Piece): WMS扫描但是无CORD记录的箱/单内扫描件数`,
  tipPiece9: `By EPC Accuracy: Accurate Qty / (CORD EPC Qty)`
}
